const AccountType = {
  ADMIN: 'admin',
  PROGRAM_MANAGER: 'programManager',
  CLUSTER_COORDINATOR: 'clusterCoordinator',
  FIELD_FACILITATOR: 'fieldFacilitator',
};

export default AccountType;
